import http from "plugins/axios";

export default {
  getUserList(data) {
    return http.get({
      url: `/ta/admin/open/log/list`,
      data
    });
  },

};
